import { render } from "./AccountingDatatableFormPaymentType.vue?vue&type=template&id=46d9bed9"
import script from "./AccountingDatatableFormPaymentType.vue?vue&type=script&lang=js"
export * from "./AccountingDatatableFormPaymentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__